export const environment = {
  production: false,
  base_api_url: "https://beta.prostocheck.com/api/",
  local: true
};
